import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import Select from "react-select";

const DetectionTechnology = ({ techData, setTechData, measurementTech }) => {
  const handleChange = (field, value) => {
    setTechData({ ...techData, [field]: value });
  };

  return (
    <div className="technology-section mb-5 p-4 bg-light border rounded">
      <h5 className="text-white p-2" style={{ backgroundColor: "#243544" }}>
        Detection Technology
      </h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Technology Used</Form.Label>
            <Select
              options={measurementTech.map((tech) => ({ value: tech.id, label: tech.name }))}
              value={
                measurementTech.filter((tech) => tech.id === techData.technologyId).map((tech) => ({ value: tech.id, label: tech.name }))[0]
              }
              onChange={(selected) => handleChange("technologyId", selected.value)}
              placeholder="Select technology"
              isSearchable
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Vendor/Provider</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter vendor or provider name"
              value={techData.provider}
              onChange={(e) => handleChange("provider", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Detection Threshold</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ex: 0.2 tons CH4/hr"
              value={techData.detectionThreshold}
              onChange={(e) => handleChange("detectionThreshold", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Spatial Resolution</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ex: 1 m² per pixel"
              value={techData.spatialResolution}
              onChange={(e) => handleChange("spatialResolution", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export { DetectionTechnology };
